import PropTypes from 'prop-types';
import React from 'react';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';
import Paper from 'ViatoUi/Shared/Surfaces/Paper';
import { Headline } from 'ViatoUi/Shared/Typo';

import styles from './Section.module.scss';

const Section = ({ darkened, lastElementOfStep, headline, children, firstElementOfStep, isFirstPage, id }) => {
	return isFirstPage ? (
		<div className={styles.wrapper}>{children}</div>
	) : (
		<Paper
			className={styles.section}
			darkened={darkened}
			data={{ 'data-darkened': darkened }}
			element='section'
			fade={lastElementOfStep}
			spacing='none'
		>
			{id !== null && <div id={id} />}
			<FlexBox alignItems='center' className={styles.wrapper} flexDirection='column'>
				{darkened && <Spacer height='l' />}
				{headline !== null && (
					<>
						{firstElementOfStep ? (
							<>
								<Headline type='display' centered>
									{headline}
								</Headline>
								<Spacer height='xxl' />
							</>
						) : (
							<>
								<Spacer height='xxl' />
								<Headline type='h1' centered>
									{headline}
								</Headline>
								<Spacer height='xl' />
							</>
						)}
					</>
				)}

				{children}
				<Spacer height='xl' />
				{darkened && <Spacer height='l' />}
			</FlexBox>
		</Paper>
	);
};

Section.propTypes = {
	isFirstPage: PropTypes.bool,
	darkened: PropTypes.bool,
	lastElementOfStep: PropTypes.bool,
	headline: PropTypes.string,
	id: PropTypes.string,
	children: PropTypes.node.isRequired,
	firstElementOfStep: PropTypes.bool
};

Section.defaultProps = {
	id: null,
	headline: null,
	isFirstPage: false,
	darkened: false,
	lastElementOfStep: false,
	firstElementOfStep: false
};

export default Section;
